<!--
 * @Author: pengyong
 * @Date: 2020-11-10 15:00:22
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-14 22:17:02
 * @Description:
 * @FilePath: /exhibit/src/views/index/components/PlayVideo.vue
-->
<template>
    <div class="video-box">
        <!-- <video
            style="object-fit: fill; width: 100%; height: 100%"
            id="videoPlay"
            webkit-playsinline="true"
            playsinline="true"
            autoplay="autoplay"
            preload="meta"
            ref="video"
        >
            <source src="https://video.ciftis.org/eportal/videoDir/cn/2020/08/2020080719122659579.mp4" type="video/mp4" />
        </video> -->
        <div class="video-bg" @click="togglePlay"></div>
        <div class="play-btn" @click="togglePlay" v-show="showPlayBtn">
            <img :src="require('@/assets/play-white.png')" alt="" />
        </div>
        <div class="skip" @click="handleSkipVideo">跳过</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showPlayBtn: true
        };
    },
    mounted() {
        this.$refs.video.addEventListener("ended", () => {
            this.$emit("onEnd");
            this.$router.push("/map");
        });
        this.$refs.video.addEventListener("play", () => {
            this.showPlayBtn = false;
            this.$emit("onPlay");
        });
        this.$refs.video.addEventListener("pause", () => {
            this.showPlayBtn = true;
            this.$emit("onPaused");
        });
    },
    methods: {
        togglePlay() {
            if (this.$refs.video.paused) {
                this.$refs.video.play();
            } else {
                this.$refs.video.pause();
            }
        },
        handleSkipVideo() {
            this.$router.push("/map");
        }
    }
};
</script>

<style lang="scss" scoped>
.video-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .play-btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 1;
        img {
            width: 12px;
            height: 16px;
        }
    }
    .skip {
        color: #fff;
        position: absolute;
        left: 60%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        cursor: pointer;
        z-index: 1;
    }
    .video-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/PlayVideo.vue